import type { SVGProps } from 'react';
type ZinniaSvgProps = SVGProps<SVGSVGElement> & {
  size: number | string,
};
const SvgNavAppsEdit = (props: ZinniaSvgProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    height={props.size}
    width={props.size}
    {...props}
  >
    <path
      fill="#88827E"
      d="M3 11h8V3H3v8Zm2-6h4v4H5V5ZM3 21h8v-8H3v8Zm2-6h4v4H5v-4ZM13 21h8v-8h-8v8Zm2-6h4v4h-4v-4ZM13 9.316V11h1.685l4.237-4.236-1.685-1.684L13 9.316ZM19.314 3l-1.191 1.19 1.686 1.686L21 4.686 19.314 3Z"
    />
  </svg>
);
export default SvgNavAppsEdit;
